import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import NoAccessBlock from '../../atoms/Icons/NoAccessBlock';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    padding: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '614px',
    backgroundColor: 'white',
    opacity: '0.9',
    borderRadius: '8px 2px 2px 8px',
    gap: '16px',
    zIndex: 10,
  },
  infoLinksContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});
export const NoFeatureAccess: React.FC<{}> = ({}) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.mainContainer}>
      <NoAccessBlock />
      <Typography fontSize="14px" textColor="#E08083" fontType="semiBold">
        Sorry, No Access To This Feature
      </Typography>
      <Typography
        fontSize="14px"
        textColor={patientAccessTheme.palette.text.lowemphasis}
        fontType="medium"
        styleProps={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        To access this feature reach out to{' '}
        <Typography
          textColor="#475CB0"
          fontSize={'14px'}
          lineHeight={'24px'}
          styleProps={{
            textDecoration: 'underline',
            textDecorationStyle: 'dashed',
            textDecorationThickness: '1px',
            textDecorationColor: '#475CB0',
            textUnderlineOffset: '4px',
            cursor: 'pointer',
          }}
          onClick={() => {
            window.location.href = 'mailto:sales@homahealth.us';
          }}
        >
          sales@homahealth.us.
        </Typography>
      </Typography>
    </Grid>
  );
};
